import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { ArtistViewState } from '@/store/types/artistView.state';
import { MuseumState } from '@/store/types/museum.state';
import Artwork from '@/models/artwork';

export const getters: GetterTree<ArtistViewState, RootState> = {
    getBirthYear(state):string{
        return `${state.artist.birthDate.getFullYear()}`;
    },
    getDeathYear(state):string{
        return `${state.artist.deathDate.getFullYear()}`;
    },
    getSortedArtworks(state):Artwork[]{
        return state.artistArtworks.sort( (a,b) => a.date - b.date );
    }
};